import KatalLogger from '@amzn/katal-logger';
import { NodeEnv } from 'src/constants';

// In development the `https://gqyojlcpnb.execute-api.us-east-1.amazonaws.com/prod/v1/log` template never gets replaced with a
// real CloudFormation value, so any logger requests go to a 404. Omit `url`
// in dev so the logger writes to the browser console instead. See KatalLogger
// docs: when `url` is undefined, logs are sent to the console.
const isProduction = process.env.NODE_ENV === NodeEnv.production;

export const logger = new KatalLogger({
  url: isProduction ? 'https://gqyojlcpnb.execute-api.us-east-1.amazonaws.com/prod/v1/log' : undefined,
  maxLogLineSize: 10000, // default 5000
  logToConsole: !isProduction,
});
